"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const Form_1 = require("antd/lib/form/Form");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const response_codes_1 = require("../../../../../assets/constants/response_codes");
const strings_1 = require("../../../../../assets/strings/strings");
const underline_1 = __importDefault(require("../../../../../components/underline"));
const auth_requests_1 = require("../../../../../dataSource/auth_requests");
const user_requests_1 = require("../../../../../dataSource/user_requests");
const RoutesPaths_1 = require("../../../../../routes/RoutesPaths");
const message_utils_1 = __importDefault(require("../../../../../utils/message_utils"));
const users_1 = require("../../../../../utils/users");
require("./ChangePasswordStyles.scss");
const ChangePassword = ({ close }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const [form] = (0, Form_1.useForm)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const history = (0, react_router_dom_1.useHistory)();
    const handleSubmit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const response = yield (0, user_requests_1.changePassword)({
            oldPassword: form.getFieldValue('oldPassword'),
            newPassword: form.getFieldValue('password'),
        });
        setLoading(false);
        if (response.code === response_codes_1.ChangePasswordCodes.SUCCESS) {
            const lastUrl = location.pathname + location.search;
            (0, users_1.setLastPageBeforeLogin)(lastUrl);
            message_utils_1.default.success({ message: strings_1.ChangePasswordMessages.passwordUpdatedSuccessfully });
            close();
            (0, auth_requests_1.userLogout)();
            (0, users_1.removeUserFromStorage)();
            history.push(RoutesPaths_1.routesPaths.login);
        }
        else {
            switch (response.code) {
                case response_codes_1.ChangePasswordCodes.error.INVALID_OLD_PASSWORD:
                    message_utils_1.default.error({
                        message: strings_1.ChangePasswordMessages.incorrectPassword,
                        description: strings_1.ChangePasswordMessages.incorrectPasswordTryAgain,
                    });
                    break;
                default:
                    message_utils_1.default.error();
                    break;
            }
        }
    }), []);
    return (react_1.default.createElement("div", { className: "ChangePasswordModal" },
        react_1.default.createElement("span", { className: "title" },
            "Criar nova",
            react_1.default.createElement("span", null, ` Senha`),
            react_1.default.createElement(underline_1.default, { style: { marginLeft: '32px', marginBottom: '30px' } })),
        react_1.default.createElement(antd_1.Form, { form: form, style: { marginTop: '30px' }, onFinish: handleSubmit },
            react_1.default.createElement("div", { className: "item" },
                react_1.default.createElement("span", null, "Senha atual *"),
                react_1.default.createElement(antd_1.Form.Item, { name: "oldPassword", rules: [
                        {
                            required: true,
                            message: 'Digite a senha atual.',
                        },
                    ] },
                    react_1.default.createElement(antd_1.Input.Password, { visibilityToggle: true }))),
            react_1.default.createElement("div", { className: "item" },
                react_1.default.createElement("span", null, "Nova senha *"),
                react_1.default.createElement(antd_1.Form.Item, { name: "password", hasFeedback: true, rules: [
                        {
                            required: true,
                            validator(_, value) {
                                if (value.length >= 6) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('A senha deve ter mais de 6 caracteres!'));
                            },
                        },
                    ] },
                    react_1.default.createElement(antd_1.Input.Password, { visibilityToggle: true }))),
            react_1.default.createElement("div", { className: "item" },
                react_1.default.createElement("span", null, "Confirme a nova senha *"),
                react_1.default.createElement(antd_1.Form.Item, { name: "newPasswdConfirm", dependencies: ['password'], hasFeedback: true, rules: [
                        {
                            required: true,
                            message: 'Please confirm your password!',
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('As senhas estão diferentes!'));
                            },
                        }),
                    ] },
                    react_1.default.createElement(antd_1.Input.Password, null))),
            react_1.default.createElement("div", { className: "footer" },
                react_1.default.createElement(antd_1.Form.Item, null,
                    react_1.default.createElement(antd_1.Button, { onClick: close, style: { borderRadius: '5px' } },
                        react_1.default.createElement("span", null, "Cancelar"))),
                react_1.default.createElement(antd_1.Form.Item, null,
                    react_1.default.createElement(antd_1.Button, { type: "primary", style: { borderRadius: '5px' }, htmlType: "submit" },
                        react_1.default.createElement("span", { style: { marginRight: '10px' } }, "Trocar Senha"),
                        loading && react_1.default.createElement(antd_1.Spin, { size: "small" })))))));
};
exports.default = ChangePassword;
